import { gsap } from 'gsap';
import { Power2 } from 'gsap';
import ScrollMagic from 'scrollmagic';
import { TimelineMax } from 'gsap';
import jQuery from 'jquery';
import MicroModal from 'micromodal';
import Barba from '@barba/core';
import App from './App';

const Visit = {
  visitReservation: function () {
    jQuery('.weekly-event__wrapper .weekly-content .event-single')
      .first()
      .addClass('mobile-active');

    checkSize();

    jQuery(window).resize(checkSize);

    function checkSize() {
      function ImageChange() {
        function removeImgClass() {
          jQuery('.reservation-img img').removeClass('active');
        }
        if (jQuery('.reservation-info .estate-tasting').hasClass('active')) {
          removeImgClass();
          jQuery('.reservation-img .estate-image').addClass('active');
        } else if (jQuery('.reservation-info .morning-tasting').hasClass('active')) {
          removeImgClass();
          jQuery('.reservation-img .morning-image').addClass('active');
        } else {
          removeImgClass();
          jQuery('.reservation-img .afternoon-image').addClass('active');
        }
      }

      if (jQuery(window).width() <= 1033) {
        // Mobile-specific functionality removed for brevity but can be uncommented if needed
      } else {
        // Desktop-specific functionality removed for brevity but can be uncommented if needed
      }

      //Active Toggle
      jQuery('.tasting-info').on('click', function () {
        if (!jQuery(this).hasClass('active')) {
          jQuery('.tasting-info').removeClass('active');
          jQuery(this).addClass('active');
        }

        // Check if the screen width is less than or equal to 1033px
        if (jQuery(window).width() <= 1033) {
          // Calculate the offset including the .site-navigation height and an additional 200px
          let offset =
            jQuery('.tasting-info.active .info-title').offset().top -
            jQuery('#site-navigation').outerHeight() -
            200;

          // Scroll to the calculated offset
          jQuery('html, body').animate(
            {
              scrollTop: offset,
            },
            250
          ); // Adjust the duration (250 ms here) as needed
        }
      });

      //Image Change
      jQuery('.tasting-info').on('click', function () {
        function removeImgClass() {
          jQuery('.reservation-img img').removeClass('active');
        }
        if (jQuery(this).hasClass('estate-tasting')) {
          //removeImgClass();
          jQuery('.reservation-img .estate-image').addClass('active');
        } else if (jQuery(this).hasClass('morning-tasting')) {
          // removeImgClass();
          jQuery('.reservation-img .morning-image').addClass('active');
        } else {
          //removeImgClass();
          jQuery('.reservation-img .afternoon-image').addClass('active');
        }
      });
    }
  },
  virtualSlider: function () {
    let $vir = jQuery('.virtual-slider__container .virtual-single');
    let $virContainer = jQuery('.virtual-slider__container');

    let $virtualCurrentNum = 1;
    let $totalVirtual = 5;

    let $virtualPanelNav = jQuery('.visit-panel-nav');
    let $virtualPanelNavLi = jQuery('.visit-panel-nav li');

    let $virBG = jQuery('.virtual-bg__container .virtual-bg-images');
    let $virBGContainer = jQuery('.virtual-bg__container');
    jQuery('.virtual-single .number .total-number').text($totalVirtual);

    function textChange() {
      jQuery('.virtual-single .number .current-number').text($virtualCurrentNum);
    }

    function NextVirtualImageChange() {
      if (jQuery('.virtual-bg__container .active').is(':last-child')) {
        $virBG.first().addClass('active');
        $virBG.last().removeClass('active');
        $virtualCurrentNum = 1;
        //textChange();
      } else {
        $virBGContainer.find('.active').next().addClass('active');
        jQuery('.virtual-bg__container .active').first().removeClass('active');
        $virtualCurrentNum++;

        //textChange();
      }
    }
    function PrevVirtualImageChange() {
      if (jQuery('.virtual-bg__container .active').is(':first-child')) {
        $virBG.last().addClass('active');
        $virBG.first().removeClass('active');
        $virtualCurrentNum = $totalVirtual;

        //textChange();
      } else {
        $virBGContainer.find('.active').prev().addClass('active');
        jQuery('.virtual-bg__container .active').last().removeClass('active');
        $virtualCurrentNum--;

        //textChange();
      }
    }

    jQuery('.virtual-slider__controller .next').on('click', function () {
      if (jQuery('.virtual-slider__container .active').is(':last-child')) {
        $vir.first().addClass('active');
        $vir.last().removeClass('active');
        $virtualPanelNavLi.first().addClass('is-active').focus();
        $virtualPanelNavLi.last().removeClass('is-active').focus();
      } else {
        $virContainer.find('.active').next().addClass('active');
        jQuery('.virtual-slider__container .active').first().removeClass('active');

        $virtualPanelNav.find('.is-active').next().addClass('is-active');
        jQuery('.visit-panel-nav .is-active').first().removeClass('is-active');
      }
      NextVirtualImageChange();
    });
    jQuery('.virtual-slider__controller .prev').on('click', function () {
      if (jQuery('.virtual-slider__container .active').is(':first-child')) {
        $vir.last().addClass('active');
        $vir.first().removeClass('active');

        $virtualPanelNavLi.last().addClass('is-active').focus();
        $virtualPanelNavLi.first().removeClass('is-active').focus();
      } else {
        $virContainer.find('.active').prev().addClass('active');
        jQuery('.virtual-slider__container .active').last().removeClass('active');

        $virtualPanelNav.find('.is-active').prev().addClass('is-active');
        jQuery('.visit-panel-nav .is-active').last().removeClass('is-active');
      }
      PrevVirtualImageChange();
    });

    $virtualPanelNavLi.on({
      click: function () {
        // console.log( jQuery(this).attr('virtual-slider'))
        let currentVirtual = jQuery(this).attr('virtual-slider');
        let currentSlider = jQuery('.virtual-slider__container');
        let $virtualPanelNavLi = jQuery('.visit-panel-nav li');
        let $virtualBg = jQuery('.virtual-bg__container .virtual-bg-images');
        let $virtualBgContainer = jQuery('.virtual-bg__container');
        let $sliderNumber = jQuery('.slide-number .active-slide-number');

        function removeClass() {
          jQuery('.virtual-slider__container .virtual-single').removeClass('active');
          $virtualPanelNavLi.removeClass('is-active');
          jQuery('.virtual-bg__container .virtual-bg-images').removeClass('active');
          $virtualBg.removeClass('active');
        }
        switch (currentVirtual) {
          case 'carriage':
            removeClass();
            currentSlider.find('.carriage-house-container').addClass('active');
            $virtualBgContainer.find('.carriage').addClass('active');
            jQuery(this).addClass('is-active');
            $sliderNumber.html('1');
            break;
          case 'redwood':
            removeClass();
            currentSlider.find('.redwood-cellar').addClass('active');
            $virtualBgContainer.find('.redwood').addClass('active');
            jQuery(this).addClass('is-active');
            $sliderNumber.html('2');
            break;
          case 'vintage':
            removeClass();
            currentSlider.find('.exterior-container').addClass('active');
            $virtualBgContainer.find('.vintage').addClass('active');
            jQuery(this).addClass('is-active');
            $sliderNumber.html('3');
            break;
          case 'reserve':
            removeClass();
            currentSlider.find('.barrel-room-container').addClass('active');
            $virtualBgContainer.find('.reserve').addClass('active');
            jQuery(this).addClass('is-active');
            $sliderNumber.html('4');
            break;
          case 'great-lawn':
            removeClass();
            currentSlider.find('.source-vineyards-container').addClass('active');
            $virtualBgContainer.find('.great-lawn').addClass('active');
            jQuery(this).addClass('is-active');
            $sliderNumber.html('5');
            break;
          default:
            break;
        }
      },
      mouseenter: function () {
        gsap.to(jQuery(this).find('p'), 0.15, {
          autoAlpha: 1,
          yPercent: -5,
          ease: 'power2.inOut',
        });
      },
      mouseleave: function () {
        gsap.to(jQuery(this).find('p'), 0.15, {
          autoAlpha: 0,
          yPercent: 0,
          ease: 'power2.inOut',
        });
      },
    });
  },
  visitVirtualModal: function () {
    MicroModal.init({
      disableScroll: true,
      closeTrigger: 'data-micromodal-close',
    });
    let openButton = document.getElementById('open-virtual-modal-1');
    let openButton2 = document.getElementById('open-virtual-modal-2');
    let openButton3 = document.getElementById('open-virtual-modal-3');
    let openButton4 = document.getElementById('open-virtual-modal-4');
    let openButton5 = document.getElementById('open-virtual-modal-5');

    openButton.addEventListener('click', function () {
      MicroModal.show('virtual-fact-modal-1');
    });
    openButton2.addEventListener('click', function () {
      MicroModal.show('virtual-fact-modal-2');
    });
    openButton3.addEventListener('click', function () {
      MicroModal.show('virtual-fact-modal-3');
      console.log('3');
    });
    openButton4.addEventListener('click', function () {
      MicroModal.show('virtual-fact-modal-4');
    });
    openButton5.addEventListener('click', function () {
      MicroModal.show('virtual-fact-modal-5');
    });
  },
  visitController: '',
  scrollAnim: function () {
    let introTL = new TimelineMax({ paused: true });
    introTL
      .fromTo(
        jQuery('.visit-intro__wrapper .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        0
      )
      .fromTo(
        jQuery('.visit-intro__wrapper .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.visit-intro__wrapper .paragraph'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.visit-intro__wrapper .gold-link'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    let introSectionHeight = jQuery('.visit-intro__wrapper').outerHeight(true);

    let introScene = new ScrollMagic.Scene({
      triggerElement: '.visit-intro__wrapper',
      duration: introSectionHeight,
      triggerHook: 0.5,
      offset: 0,
      // reverse:true
    })
      .on('enter', function (event) {
        introTL.play();
      })
      .on('leave', function (event) {}); //.addIndicators({name: "intro"});

    let resTL = new TimelineMax({ paused: true });
    resTL
      .fromTo(
        jQuery('.reservation-img '),
        0.8,
        { x: -18, ease: Power2.easeIn },
        { x: 0, ease: Power2.easeInOut },
        0
      )
      .fromTo(
        jQuery('.reservation-info'),
        0.8,
        { x: 18, ease: Power2.easeIn },
        { x: 0, ease: Power2.easeInOut },
        0
      );

    let resSectionHeight = jQuery('.visit-reservation__wrapper').outerHeight(true);

    let reservationScene = new ScrollMagic.Scene({
      triggerElement: '.visit-reservation__wrapper',
      duration: resSectionHeight,
      triggerHook: 0.5,
      offset: 0,
      // reverse:true
    })
      .on('enter', function (event) {
        resTL.play();
      })
      .on('leave', function (event) {}); //.addIndicators({name: "intro"});

    let threeSixtyTL = new TimelineMax({ paused: true });
    threeSixtyTL
      .fromTo(
        jQuery('.intro-virtual .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.intro-virtual .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    let threeSixtyHeight = jQuery('.tasting-360__wrapper').outerHeight(true);

    let threeSixtyScene = new ScrollMagic.Scene({
      triggerElement: '.tasting-360__wrapper',
      duration: threeSixtyHeight,
      triggerHook: 0.5,
      offset: 0,
      // reverse:true
    })
      .on('enter', function (event) {
        threeSixtyTL.play();
      })
      .on('leave', function (event) {}); //.addIndicators({name: "intro"});

    let experienceTL = new TimelineMax({ paused: true });

    experienceTL
      .fromTo(
        jQuery('.custom-exp-container .custom-img'),
        0.8,
        { autoAlpha: 0, x: -18, ease: Power2.easeIn },
        { autoAlpha: 1, x: 0, ease: Power2.easeInOut },
        '-=0'
      )
      .fromTo(
        jQuery('.custom-exp-container .custom-content .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.custom-exp-container .custom-content .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.custom-exp-container .custom-content .paragraph'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.custom-exp-container .custom-content .gold-link'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    let expHeight = jQuery('.custom-experiences__wrapper').outerHeight(true);

    let expScene = new ScrollMagic.Scene({
      triggerElement: '.custom-experiences__wrapper',
      duration: expHeight,
      triggerHook: 0.5,
      offset: 0,
      // reverse:true
    })
      .on('enter', function (event) {
        experienceTL.play();
      })
      .on('leave', function (event) {}); //.addIndicators({name: "intro"});

    let cucinaTL = new TimelineMax({ paused: true });

    cucinaTL
      .fromTo(
        jQuery('.cucina__wrapper .image-container img'),
        0.8,
        { x: -18, ease: Power2.easeIn },
        { x: 0, ease: Power2.easeInOut },
        '-=0'
      )
      .fromTo(
        jQuery('.cucina__wrapper .cucina__content .text-container .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.cucina__wrapper .cucina__content .text-container .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.cucina__wrapper .cucina__content .text-container .paragraph'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.cucina__wrapper .cucina__content .pizza-link '),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      );

    let cucinaHeight = jQuery('.cucina__wrapper').outerHeight(true);

    let cucinaScene = new ScrollMagic.Scene({
      triggerElement: '.cucina__wrapper',
      duration: cucinaHeight,
      triggerHook: 0.5,
      offset: 0,
      // reverse:true
    })
      .on('enter', function (event) {
        cucinaTL.play();
      })
      .on('leave', function (event) {}); //.addIndicators({name: "intro"});

    let eventsTL = new TimelineMax({ paused: true });

    eventsTL
      .fromTo(
        jQuery('.weekly-event__wrapper .weekly-intro .subtitle'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .fromTo(
        jQuery('.weekly-event__wrapper .weekly-intro .title'),
        0.5,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        '-=.25'
      )
      .staggerFromTo(
        jQuery('.events-container .single-event'),
        1,
        { y: 8, autoAlpha: 0, ease: Power2.easeIn },
        { y: 0, autoAlpha: 1, ease: Power2.easeIn },
        0.25
      );

    let eventHeight = jQuery('.weekly-event__wrapper').outerHeight(true);

    let eventsScene = new ScrollMagic.Scene({
      triggerElement: '.weekly-event__wrapper',
      duration: eventHeight,
      triggerHook: 0.5,
      offset: 0,
      // reverse:true
    })
      .on('enter', function (event) {
        eventsTL.play();
      })
      .on('leave', function (event) {}); //.addIndicators({name: "intro"});

    this.visitController.addScene([
      introScene,
      reservationScene,
      threeSixtyScene,
      expScene,
      cucinaScene,
      eventsScene,
    ]);
  },
  // eventTruncateText : function() {
  //     jQuery('.weekly-content .event-paragraph').truncate({
  //         width: '900px'
  //     })
  // },
  removeVideoCaptions: function () {
    let vid = document.getElementById('visit-reso-video');

    if (vid && vid.textTracks && vid.textTracks[0]) {
      vid.textTracks[0].mode = 'hidden';
    }
  },
  addInfoResoList: function () {
    // get url of  web page
    let href = window.location.href;
    let url = new URL(href);

    function pollForElement(selector, maxAttempts, interval, callback) {
      let attempts = 0;

      const poll = setInterval(() => {
        const element = document.querySelector(selector);
        console.log(element);

        if (element) {
          clearInterval(poll);
          callback(null, element);
        } else {
          attempts++;
          if (attempts >= maxAttempts) {
            clearInterval(poll);
            callback(new Error(`Element not found after ${maxAttempts} attempts`));
          }
        }
      }, interval);
    }

    // if url contains /reservation/reservationlist/ then add info to reservation list
    if (url.pathname.includes('/reservation/reservationlist/')) {
      setTimeout(() => {
        pollForElement('#ecpi_reservationlist_info', 20, 500, (err, element) => {
          if (err) {
            console.error(err);
          } else {
            //let infoPara = document.querySelector('#ecpi_reservationlist_info');
            let resoWrapper = document.querySelector('.reservation__wrapper');
            let foodWinePairing = document.querySelector(
              'div[data-ecp-id = "Food_&_Wine_Tasting"]'
            );

            let contactInfo = `<div class="ecp-component">
          <p>Please choose an experience to see available times.</p>
          <p>For more information, call our concierge at <a href="tel:7079672229" style="color: #d4b68e;">707.967.2229</a> or 
          email <a href="mailto:reservations@charleskrug.com" style="color: #d4b68e;">reservations@charleskrug.com</a>.</p>
          </div>`;

            let postListInfo = `<div style="margin-top:4rem;" class="ecp-component">
          <p>For more information, call our concierge at <a href="tel:7079672229" style="color: #d4b68e;">707.967.2229</a> or 
          email <a href="mailto:reservations@charleskrug.com" style="color: #d4b68e;">reservations@charleskrug.com</a>.</p>
          </div>`;

            let foodWineInfo = `<div class="ecp-component">
          <p>Limited to individuals 21 year of age or older.</p> 
          <p>Please notify us of dietary restrictions when making your reservation. </p>
          <p>This is not a private experience; you may be paired with other guests.</p>
          <p style="margin-top: 2rem;">** Due to the planning and food preparation, if you should need to make changes or cancel your reservation, please notify us 48 hours prior to your reservation. Please note, cancellations and changes made within 48 hours of your reservation will be charged in full for this experience. **</p>
          </div>`;

            element.innerHTML = contactInfo;
            resoWrapper.insertAdjacentHTML('beforeend', postListInfo);
            //foodWinePairing.querySelector('button').remove();
            foodWinePairing
              .querySelector('.ecp-reservation')
              .insertAdjacentHTML('beforeend', foodWineInfo);
          }
        });
      }, 250);
    }
  },
  tockTrigger: function () {
    document.addEventListener('click', function (event) {
      const target = event.target;

      if (target.matches('.reserve-btn-link')) {
        console.log("Clicked on 'RESERVE YOUR...' link");

        // Always prevent default behavior to control the flow
        event.preventDefault();

        const wrapper = target.closest('.reserve-wrapper');
        if (wrapper) {
          const tockButtonLink = wrapper.querySelector('.TockButton-link');
          // If the Tock button link exists, click it
          if (tockButtonLink) {
            console.log('Found the Tock button link, clicking it');
            tockButtonLink.click();
            return; // Ensure we don't proceed further
          } else {
            console.log('Did not find the Tock button link inside the wrapper');
          }
        } else {
          console.log('Did not find the reserve-wrapper for the clicked link');
        }

        // If the Tock button link doesn't exist or the wrapper is missing, redirect to the original link
        console.log('Redirecting to the original link');
        window.location.href = target.href;
      }
    });
  },
  init: function () {
    console.log('Visit.init called');

    // Initialize only if we're on the visit page (check for needed elements)
    if (document.querySelector('.visit-reservation__wrapper')) {
      this.visitReservation();
    }

    if (document.querySelector('.virtual-slider__container')) {
      this.virtualSlider();
    }

    if (document.querySelector('#open-virtual-modal-1')) {
      this.visitVirtualModal();
    }

    // Create the controller only if it doesn't exist
    if (!this.visitController) {
      this.visitController = new ScrollMagic.Controller();
    }

    this.removeVideoCaptions();

    window.addEventListener('load', () => {
      this.tockTrigger();
    });
  },

  // This ensures the ScrollMagic animations are properly initialized
  initScrollAnimations: function () {
    console.log('Visit: initializing scroll animations');

    // Make sure we have a controller
    if (!this.visitController) {
      console.log('Creating new ScrollMagic controller');
      this.visitController = new ScrollMagic.Controller();
    }

    // Run the scroll animations
    try {
      this.scrollAnim();
      console.log('ScrollMagic animations initialized successfully');
    } catch (e) {
      console.error('Error initializing ScrollMagic animations:', e);
    }
  },
};

// Define Barba.js hooks for namespaces
// Update to modern barba.js hooks instead of BaseView.extend
const visitHooks = {
  beforeEnter(data) {
    // The new Container is ready and attached to the DOM.
    console.log('Visit: beforeEnter', data);

    // Check if the controller exists and destroy it to prevent duplicates
    if (Visit.visitController) {
      try {
        Visit.visitController.destroy(true);
        Visit.visitController = null;
        console.log('Destroyed previous ScrollMagic controller');
      } catch (e) {
        console.error('Error destroying Visit controller:', e);
      }
    }
  },

  enter(data) {
    // The new Container is ready and attached to the DOM.
    console.log('Visit: enter', data);

    // Wait for DOM to be fully ready before initializing
    setTimeout(() => {
      Visit.init();
      console.log('Visit.init completed');
    }, 100);
  },

  afterEnter(data) {
    // The Transition has just finished.
    console.log('Visit: afterEnter', data);

    // Wait for styles to be applied and DOM to be stable
    setTimeout(() => {
      if (!App.isMobile()) {
        Visit.initScrollAnimations();
      } else {
        console.log('Mobile device detected, skipping scroll animations');
      }
    }, 500);
  },

  leave(data) {
    // A new Transition toward a new page has just started.
    console.log('Visit: leave', data);

    if (Visit.visitController) {
      try {
        Visit.visitController.destroy(true);
        Visit.visitController = null;
        console.log('Controller destroyed during leave');
      } catch (e) {
        console.error('Error destroying Visit controller:', e);
      }
    }
  },
};

const resoHooks = {
  beforeEnter(data) {
    // The new Container is ready and attached to the DOM.
    console.log('Reservation: beforeEnter', data);
  },

  enter(data) {
    // The new Container is ready and attached to the DOM.
    console.log('Reservation: enter', data);

    setTimeout(() => {
      Visit.addInfoResoList();
    }, 250);
  },

  leave(data) {
    // A new Transition toward a new page has just started.
    console.log('Reservation: leave', data);

    if (Visit.visitController) {
      try {
        Visit.visitController.destroy(true);
        Visit.visitController = null;
      } catch (e) {
        console.error('Error destroying Visit controller:', e);
      }
    }
  },
};

// Export hooks as part of Visit for Barba to use
Visit.barbaHooks = {
  visit: visitHooks,
  reservation: resoHooks,
};

export default Visit;
